import { LightUserModel } from '../../../shared/data/models/light-user.model';
import { MessageState } from './message.state';
import { MessagesDataState } from './messages-data.state';

export interface ThreadState {
  Id: string;
  participants?: LightUserModel[];
  groupDetail?: LightUserModel;
  latestMessage: MessageState;
  messages: MessagesDataState;
}

export const initialThreadState: ThreadState = {
  Id: null,
  participants: [],
  groupDetail: null,
  latestMessage: null,
  messages: null
};
